import { configureStore } from '@reduxjs/toolkit';
import { classActionMiddleware } from '@/store/_setup/classActionMiddleware';
import { listApi } from '@/api/listApi';
import { communitiesApi } from '@/api/communitiesApi';

import { designerReducer } from '@/store/designer/designerReducer';
import { listReducer } from '@/store/lists/listReducer';
import { notificationsReducer } from '@/store/notifications/reducer/notificationsReducer';
import { userReducer } from '@/store/user/reducer/userReducer';
import { discussionsApi } from '@/features/discussions/discussionsApi';
import { themeReducer } from '@/features/theme';

export const store = configureStore({
  reducer: {
    designer: designerReducer,
    user: userReducer,
    notifications: notificationsReducer,
    lists: listReducer,
    theme: themeReducer,
    [listApi.reducerPath]: listApi.reducer,
    [discussionsApi.reducerPath]: discussionsApi.reducer,
    [communitiesApi.reducerPath]: communitiesApi.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      classActionMiddleware,
      listApi.middleware,
      discussionsApi.middleware,
      communitiesApi.middleware
    ),
  devTools: process.env.NODE_ENV !== 'production'
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
